import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BeigabenAusloeserServiceConfig = {
  name: "BeigabenAusloeser",
  annotations: []
} as ServiceConfig;